module.exports = "data:image/gif;base64,R0lGODlhEAAQANUwAGtra2RkZL6+vkVFRZaWlpeXl2BgYISEhIKCgoiIiFZWVnFxcV1dXWpqapSUlFBQUHd3d0pKSnx8fGFhYcHBwYODg7y8vKurq7GxsX5+fqqqqnZ2dru7u4WFhZCQkJ6eno6OjoCAgGVlZWxsbHl5eV5eXp+fn4GBgY2NjXBwcKysrIeHh39/f29vb5GRkXh4eP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAADAALAAAAAAQABAAAAZkQJhwSCwaj0eCCWREGB0UJ3ElMXo41WFCADEmMF1hRUBYGDsaMywkuBwAxswHzrKoCq+AcePQw1oFBw0MRikuhEIGIwEKRg0ojUMlBg9GIieVRBMRRhMknEUDRgADokinqKlDQQA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/grid/page-first.gif
 ** module id = 436
 ** module chunks = 0
 **/